var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 19563"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00195312,
    width: 32.0016,
    height: 32,
    rx: 8,
    fill: "#34CC32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.398 7.49206C23.2978 6.38078 21.9874 5.49967 20.5432 4.90013C19.0989 4.30059 17.5497 3.99462 15.986 4.00007C9.43403 4.00007 4.09405 9.34005 4.09405 15.892C4.09405 17.992 4.64605 20.032 5.67804 21.832L3.99805 28L10.298 26.344C12.038 27.292 13.994 27.796 15.986 27.796C22.538 27.796 27.878 22.456 27.878 15.904C27.878 12.724 26.642 9.73605 24.398 7.49206ZM15.986 25.78C14.21 25.78 12.47 25.3 10.946 24.4L10.586 24.184L6.84204 25.168L7.83804 21.52L7.59804 21.148C6.61133 19.5724 6.08741 17.7511 6.08604 15.892C6.08604 10.4441 10.526 6.00407 15.974 6.00407C18.614 6.00407 21.098 7.03606 22.958 8.90806C23.879 9.82481 24.6088 10.9152 25.1053 12.1162C25.6017 13.3171 25.8548 14.6046 25.85 15.904C25.874 21.352 21.434 25.78 15.986 25.78ZM21.41 18.388C21.11 18.244 19.646 17.524 19.382 17.416C19.106 17.32 18.914 17.272 18.71 17.56C18.506 17.86 17.942 18.532 17.774 18.724C17.606 18.928 17.426 18.952 17.126 18.796C16.826 18.652 15.866 18.328 14.738 17.32C13.85 16.528 13.262 15.556 13.082 15.256C12.914 14.956 13.058 14.8 13.214 14.644C13.346 14.512 13.514 14.296 13.658 14.128C13.802 13.96 13.862 13.828 13.958 13.636C14.054 13.432 14.006 13.264 13.934 13.12C13.862 12.976 13.262 11.512 13.022 10.9121C12.782 10.3361 12.53 10.4081 12.35 10.3961H11.774C11.57 10.3961 11.258 10.4681 10.982 10.7681C10.718 11.0681 9.95003 11.788 9.95003 13.252C9.95003 14.716 11.018 16.132 11.162 16.324C11.306 16.528 13.262 19.528 16.238 20.812C16.946 21.124 17.498 21.304 17.93 21.436C18.638 21.664 19.286 21.628 19.802 21.556C20.378 21.472 21.566 20.836 21.806 20.14C22.058 19.444 22.058 18.856 21.974 18.724C21.89 18.592 21.71 18.532 21.41 18.388Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whats_app.aaf8647033f2871eacaf883414f04eaa.svg";
export { ForwardRef as ReactComponent };